window.addEventListener('load', function() {
  // Select the details element inside .flex-main-blog
  var detailsElement = document.querySelector('.flex-main-blog details');

  // Check if the details element has the 'open' attribute, and remove it if present
  if (detailsElement && detailsElement.hasAttribute('open')) {
    detailsElement.removeAttribute('open');
  }

  // Show the details element once JS is applied
  detailsElement.style.display = 'block';
});
